import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { tcnApi, money } from './api';

const types = { COMBO: 'Combo', COMBO_DUO: 'Combo dúo', SNACK: 'Solo snacks', DRINK: 'Solo bebidas' };
export default function TcnTemplateSuggestions({ device, isAdmin, onRefresh, revision }) {
    const [saving, setSaving] = useState(false);
    const [loading, setLoading] = useState(false);
    const [proposal, setProposal] = useState(null);
    const [error, setError] = useState('');
    useEffect(() => {
        let active = true;
        setProposal(null); setError('');
        if (!device.machineType) { setLoading(false); return undefined; }
        setLoading(true);
        tcnApi(`devices/${encodeURIComponent(device.deviceId)}/template`).then(data => { if (active) setProposal(data); })
            .catch(e => { if (active) setError(e.message); }).finally(() => { if (active) setLoading(false); });
        return () => { active = false; };
    }, [device.deviceId, device.machineType, device.lastSlotsSyncedAt, revision]);
    async function save(value) {
        setSaving(true); setError('');
        try {
            await tcnApi(`devices/${encodeURIComponent(device.deviceId)}/type`, { method: 'PATCH', data: { machineType: value || null } });
            await onRefresh();
        } catch (e) { setError(e.message); }
        finally { setSaving(false); }
    }
    return <section aria-label="Plantilla de planograma">
        <h3>Tipo y sugerencias de planograma</h3>
        {error && <p role="alert">{error}</p>}
        <label>Tipo de máquina <select aria-label="Tipo de máquina" disabled={!isAdmin || saving} value={device.machineType || ''} onChange={e => save(e.target.value)}>
            <option value="">Sin tipo</option>{Object.entries(types).map(([code, name]) => <option key={code} value={code}>{name}</option>)}
        </select></label>
        <p>Elegir un tipo solo habilita sugerencias. No cambia productos asignados, carriles, existencias ni precios de la máquina.</p>
        {!device.machineType && <p>Sin tipo: la máquina funciona sin sugerencias de plantilla.</p>}
        {loading && <p role="status">Cargando sugerencias…</p>}
        {!loading && proposal && <>
            <p>{proposal.template ? `Plantilla: ${proposal.template.name}` : 'No hay una plantilla activa para este tipo.'}</p>
            {proposal.omittedSlotIds?.length > 0 && <p>Posiciones de la plantilla ausentes en esta máquina: {proposal.omittedSlotIds.join(', ')}. No se crean carriles.</p>}
            <DataTable value={proposal.suggestions || []} responsiveLayout="scroll" emptyMessage="Sin sugerencias cargadas para los carriles actuales.">
                <Column field="slotId" header="Carril real" />
                <Column header="Producto sugerido" body={row => row.product ? `${row.product.name} · ${row.product.familyCode || row.product.code}${row.product.active ? '' : ' (inactivo)'}` : 'Sin producto sugerido'} />
                <Column field="capacity" header="Capacidad sugerida" />
                <Column header="Precio sugerido" body={row => row.suggestedPriceCents == null ? 'Sin precio sugerido' : money(row.suggestedPriceCents)} />
            </DataTable>
            <p>Solo propuesta de referencia. Precio y stock reales se muestran en los carriles leídos de Ourvend.</p>
        </>}
    </section>;
}
